<template>
  <certificate-default
    :infocar="infocar"
    :prezzi-vendere="prezziVendere"
    :prezzi-comprare="prezziComprare"
    :prezzi-assicurare="prezziAssicurare"
    :type="type"
    :vehicle_type="vehicle_type"
  >
  </certificate-default>
</template>

<script>
import CertificateDefault from './CertificateDefault.vue';
import CertificateClassic from './CertificateClassic.vue';
export default {
  name: 'QuotationContainer',
  components: {
    CertificateDefault,
    CertificateClassic,
  },
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    prezziVendere: {
      type: Object,
      required: true,
    },
    prezziComprare: {
      type: Object,
      required: true,
    },
    prezziAssicurare: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    vehicle_type: {
      type: String,
      required: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/QuotationContainer.vue